<!--
  ~ Copyright (c) 1999 - 2020 Accorto, Inc. - All rights reserved.
  -->

<form (keydown.enter)="$event.preventDefault()"
      [formGroup]="fm.formGroup"
      [ngClass]="formClasses"
      autocomplete="off"
      id="{{ui.uiId}}-form"
      novalidate
      role="list">


  <div *ngIf="isShowTabs"
       style="min-height: 350px">
    <div class="slds-tabs_default">
      <ul class="slds-tabs_default__nav" role="tablist">
        <li *ngFor="let section of tabList"
            [class.slds-is-active]="activeTab === section.id"
            class="slds-tabs_default__item"
            role="presentation">
          <a (click)="onTabClick(section.id)"
             [attr.aria-controls]="'tab-' + section.id"
             [attr.aria-selected]="activeTab === section.id"
             [tabindex]="activeTab === section.id ? 0 : -1"
             class="slds-tabs_default__link"
             id="tab-{{section.id}}__item"
             role="tab">{{section.name}}
          </a>
        </li>
      </ul>
    </div>

    <section *ngFor="let section of tabList"
             [attr.aria-labelledby]="'tab-' + section.id + '__item'"
             [class.slds-hide]="activeTab !== section.id"
             [class.slds-show]="activeTab === section.id"
             class="slds-tabs_default__content"
             id="tab-{{section.id}}"
             role="tabpanel">
      <acc-form-section [fm]="fm"
                        [isInTab]="true"
                        [record]="record"
                        [section]="section"
                        class="slds-section slds-is-open">
      </acc-form-section>
    </section>
  </div>


  <acc-form-section *ngFor="let section of sectionList"
                    [fm]="fm"
                    [record]="record"
                    [section]="section"
                    class="slds-section slds-is-open">
  </acc-form-section>

  <!-- button footer -->
  <footer *ngIf="showFooter"
          class="slds-section slds-m-horizontal_small slds-text-align_right">
    <button (click)="onClose()"
            *ngIf="showClose"
            class="slds-button slds-button_neutral slds-float_left slds-m-right_small"
            i18n-title
            id="mf-close"
            title="Close Editor" type="button">
      <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
        <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
      </svg>
      <span i18n>Close</span>
    </button>
    <div class="slds-text-color_error slds-float_left" id="{{ui.uiId}}-error" style="max-width: 40%;">
      {{fm.statusInfo}}
    </div>
    <ng-container *ngIf="isReadWrite">
      <button (click)="doReset()"
              [title]="fm.changeInfo"
              class="slds-button slds-button_neutral"
              id="{{ui.uiId}}-reset"
              type="button">
        <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#undo"></use>
        </svg>
        <span i18n>Reset</span>
      </button>
      <button (click)="doSave()"
              [disabled]="recordUnchanged"
              class="slds-button slds-button_brand"
              id="{{ui.uiId}}-save"
              title="Save/Submit" type="button">
        <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#connected_apps"></use>
        </svg>
        {{saveLabel}}
      </button>
    </ng-container>
  </footer>

  <acc-spinner *ngIf="busy"></acc-spinner>

</form>

<!-- debug footer -->
<div *ngIf="debug"
     class="slds-section">
  <small>
    <p style="word-break: break-word">Record: {{ fm.record | json }}</p>
    <p style="color: blue">FormGroup: {{ fm.formGroup.value | json }}</p>
    <p>Status: {{ fm.formGroup.status }} - {{ fm.statusInfoX }}</p>
  </small>
</div>
